/** Customers infra API — repos, helpers de infra y cache de snapshot. */

export {
  countCustomerAccounts,
  createCustomer,
  DEFAULT_MOVEMENTS_PAGE_SIZE,
  fetchCustomerAccounts,
  fetchCustomerMovements,
  getCustomerAccountById,
  getCustomerMovementHistory,
  getCustomerMovementHistoryForExport,
  getCustomerDaySummary,
  getOrCreatePortalToken,
  recordCustomerCharge,
  recordCustomerPayment,
  toggleCustomerBlockState,
  updateCustomerNameAndCuit,
  updateCustomerProfile,
  getCustomerSalesForCustomer,
} from './infra/customerRepository';

export { buildCustomerMovementHistoryCsv } from './infra/history/customerMovementHistoryCsv';

export { loadWebCustomerSnapshot, clearWebCustomerSnapshotCache, getWebCustomerSnapshotCache, getWebCustomerSnapshotGeneration, applyWebCustomerRemoteSnapshot } from './infra/webCustomerSnapshotCache';

// F-19: bandeja global de seguimiento
export { countPendingTasks, listPendingTasks } from './infra/customer360Repo';

// Nombres para vistas cross-module (cartera de cheques en Caja)
export { listCustomerNamesByIds } from './infra/customerAccounts';

// Adjuntos de movimientos (evidencia de cheques en cartera — lectura)
export {
  listCustomerMovementAttachments,
  createCustomerMovementAttachmentUrl,
  type CustomerMovementAttachmentRow,
} from './infra/customerMovementAttachmentsRepo';
